<template>
  <div>
    <div class="row">
      <idc-card :idcData="item" @selectIdc="idcSelect(item)" v-for="(item, index) in idcList" :key="index"/>
    </div>
    <div class="btn-wrap mt-30 justify-content-center">
      <button class="btn btn-lg line-2" @click="prev()" v-if="false"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="next()" :disabled="isCheckNext">다음<i class="icon-arrow-line-right ml-5"></i></button>
    </div>
  </div>
</template>

<script>
  import IdcCard from './IdcCard.vue'
  export default {
    components: { IdcCard },
    data(){
      return {
        selectIdc: null,
        idcList: null
      }
    },
    mounted(){
      this.loadData();
    },
    computed:{
      isCheckNext(){
        if(this.selectIdc == null)
          return true;
        else
          return false;
      }
    },
    methods: {
      loadData(){
        var that = this;
        this.$http.get('/api/public/location/idcList')
          .then((result) => {

            result.data.map((x)=>{
              x.isChecked = false;
            })
            that.idcList = result.data.filter((x)=> x.isDeleteYN == "N");
          }).catch((e) =>{
          console.log(e);
        })
      },
      idcSelect(item){
        var that = this;
        that.idcList.map((x)=>{
          x.isChecked = false;
        })
        that.idcList.map((x)=>{
          if(x.locationName == item.locationName){
            x.isChecked = true;
            that.selectIdc = x;
          }
        })
        //this.$forceUpdate();

      },
      next(){
        var that = this;
        this.idcList.forEach((x) => {
          if(x.isChecked == true) {
            that.selectIdc = x;
            return;
          }
        })
        var query = Object.assign({},this.$route.query);
        query.locationCode = this.selectIdc.locationCode;
        this.$router.push({ path: '/app/main/agree', query: query})
      }
    }
  }
</script>

<style></style>

